import CustomCheckbox from "../../../../../components/CustomCheckbox";

/**
 * ── 변경사항 ──
 * className="ws-paragraph-list ws-scroll" 추가 — 모바일에서 상단 영역으로 전환
 * (WorksheetModalV2.css의 @media 768px 규칙이 적용됨)
 * 로직은 기존 그대로.
 */
const ParagraphList = ({
  worksheetTitle,
  worksheetData,
  activeParagraph,
  setActiveParagraph,
  selectedParagraphs,
  setSelectedParagraphs,
}) => {
  const isAllSelected =
    worksheetData.length > 0 &&
    worksheetData.every((_, i) => selectedParagraphs.includes(i));

  const handleParagraphClick = (index) => {
    setActiveParagraph(worksheetData[index]);
  };

  const handleCheckboxClick = (index) => {
    setSelectedParagraphs((prev) => {
      if (prev.includes(index)) {
        return prev.filter((item) => item !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedParagraphs(worksheetData.map((_, i) => i));
    } else {
      setSelectedParagraphs([]);
    }
  };

  return (
    <div
      className="ws-paragraph-list ws-scroll"
      style={{
        width: "280px",
        flexShrink: 0,
        minHeight: 0,
        borderRight: "1px solid #ECF1F2",
        padding: "20px",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        boxSizing: "border-box",
      }}
    >
      <div style={{ fontSize: "1rem", fontWeight: 800, marginBottom: "3px", color: "#0E141B", letterSpacing: "-0.01em" }}>
        출제 지문 선택
      </div>
      <div style={{ fontSize: "0.82rem", color: "#7A8490", marginBottom: "20px" }}>
        {worksheetTitle}
      </div>
      <div
        style={{
          padding: "9px 0",
          marginBottom: "8px",
          display: "flex",
          borderBottom: "1.5px solid #0E141B",
        }}
      >
        <CustomCheckbox
          checked={isAllSelected}
          onChange={() => handleSelectAll(!isAllSelected)}
        />
        <div
          style={{
            marginLeft: "10px",
            fontSize: "0.86rem",
            fontWeight: 800,
            color: "#3A434E",
            cursor: "pointer",
          }}
          onClick={() => handleSelectAll(!isAllSelected)}
        >
          전체 선택
        </div>
      </div>

      {worksheetData.map((paragraph, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "2px",
            padding: "7px 6px",
            borderRadius: "9px",
            cursor: "pointer",
            backgroundColor:
              activeParagraph === worksheetData[index] ? "#F4F8F7" : "#fff",
            transition: "background-color .12s",
          }}
          onClick={() => handleParagraphClick(index)}
        >
          {/* 줄을 누르면 미리보기, 체크박스를 누르면 선택이다. 서로 다른 동작이라
              체크박스에서 난 클릭이 줄까지 올라가면 안 된다. change 이벤트에서
              멈추는 것으로는 click 이 그대로 올라가므로 클릭 자체를 끊는다. */}
          <span onClick={(e) => e.stopPropagation()}>
            <CustomCheckbox
              checked={selectedParagraphs.includes(index)}
              onChange={() => handleCheckboxClick(index)}
            />
          </span>
          <span
            style={{
              marginLeft: "10px",
              fontSize: "0.86rem",
              fontWeight: selectedParagraphs.includes(index) ? 700 : 500,
              color: selectedParagraphs.includes(index) ? "#0E141B" : "#7A8490",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {paragraph.title || `Paragraph ${index + 1}`}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ParagraphList;
